
export function syncBattleInput(game:any){
 if(!game?.canvas||!game.scale)return;
 const rect=game.canvas.getBoundingClientRect();if(!rect.width||!rect.height)return;
 game.scale.updateBounds();
 game.scale.displayScale.set(game.scale.gameSize.width/rect.width,game.scale.gameSize.height/rect.height);
}
